import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { PhonePurchaseErrorComponent } from './phone-purchase-error.component';

@Injectable()
export class PhonePurchaseErrorService {
  constructor(private dialog: MatDialog) {}

  public open(errorMsg: string, goBackMsg: string, continueMsg: string): Observable<boolean> {
    let dialogRef: MatDialogRef<PhonePurchaseErrorComponent>;

    dialogRef = this.dialog.open(PhonePurchaseErrorComponent);
    dialogRef.componentInstance.errorMsg = errorMsg;
    dialogRef.componentInstance.goBackMsg = goBackMsg;
    dialogRef.componentInstance.continueMsg = continueMsg;
    return dialogRef.afterClosed();
  }
}
